export default "__VITE_ASSET__82203924__"